import { useState, useEffect } from 'react'
import { Expandable } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { CaseFormSection } from '..'
import { useTranslation } from 'react-i18next'

export const MemorialContributions = ({
  saveCase,
  setActiveTab,
  activeTab,
}) => {
  const { t } = useTranslation()
  const [expandedMemorialContribution, setExpandedMemorialContribution] =
    useState(true)

  useEffect(() => {
    setExpandedMemorialContribution(true)
  }, [activeTab])

  const saveAndContinue = () => {
    setExpandedMemorialContribution(false)
    setActiveTab(t('caseDetails.tabs.casePreferences.title'))
    saveCase()
    // TODO: add this back in.
    // This is the final save - close the modal if callback provided
    // if (onFinalSave) {
    //   onFinalSave()
    // }
  }

  return (
    <Flex column full padding="0 48px 0 0">
      <Flex column align="flex-start">
        <Expandable
          margin="0 0 32px 0"
          title={t(
            'caseDetails.tabs.memorialContributions.memorialContributions',
          )}
          show={[expandedMemorialContribution, setExpandedMemorialContribution]}
          full
        >
          <CaseFormSection
            formSection="memorialContributions"
            saveAndContinue={saveAndContinue}
          />
        </Expandable>
      </Flex>
    </Flex>
  )
}

export default MemorialContributions
